import { render, staticRenderFns } from "./ManageAdminGroups.vue?vue&type=template&id=1c55479d&scoped=true"
import script from "./ManageAdminGroups.vue?vue&type=script&lang=js"
export * from "./ManageAdminGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageAdminGroups.vue?vue&type=style&index=0&id=1c55479d&prod&scoped=true&lang=css"
import style1 from "./ManageAdminGroups.vue?vue&type=style&index=1&id=1c55479d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55479d",
  null
  
)

export default component.exports